import { useEffect } from "react"

import { observer } from "mobx-react-lite"

import { StudentAssignmentsPresenter } from "./presenter/StudentAssignmentsPresenter"
import { StudentAssignmentsTable } from "./StudentAssignmentsTable"
import { PageLayout } from "../components/PageLayout"

interface StudentAssignmentsListProps {
  presenter: StudentAssignmentsPresenter
}

export const StudentAssignmentsList = observer(
  ({ presenter }: StudentAssignmentsListProps) => {
    useEffect(() => {
      presenter.load()
    }, [presenter])

    return (
      <PageLayout title="Assignments">
        {presenter.isLoading ? (
          <div className="tw-text-center tw-py-8">Loading Assignments...</div>
        ) : presenter.error ? (
          <div className="tw-text-center tw-text-destructive tw-py-8">
            {presenter.error}
          </div>
        ) : presenter.rowViewModels.length === 0 ? (
          <div className="tw-text-center tw-py-8">
            When your teacher assigns you work, it will show up here!
          </div>
        ) : (
          <div className="tw-bg-white tw-shadow tw-overflow-hidden">
            <StudentAssignmentsTable
              rows={presenter.rowViewModels}
              onAssignmentClick={(row) => presenter.handleAssignmentClick(row)}
            />
          </div>
        )}
      </PageLayout>
    )
  },
)
